import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const ChangePassword = () => {
  const [input, setInput] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  const handleInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;

    setInput({ ...input, [name]: value });
  };

  //   Confirm === NewPassword
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (input.new_password !== input.confirm_password) {
      alert("Passwords do not match");
      return;
    }
    try {
      await axios.post(
        "https://dev-example.sanbercloud.com/api/change-password",
        input,
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      );
      alert("Password changed successfully");
    } catch (error) {
      console.error("Error changing password:", error);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="p-8 max-w-md mx-auto bg-white rounded-xl shadow-md"
    >
      <div className="mb-6">
        <label
          htmlFor="current_password"
          className="block text-lg font-medium mb-2"
        >
          Current Password
        </label>
        <input
          id="current_password"
          type="password"
          name="current_password"
          value={input.current_password}
          onChange={handleInput}
          placeholder="Enter your current password"
          className="border rounded px-4 py-3 w-full text-lg"
        />
      </div>
      <div className="mb-6">
        <label
          htmlFor="new_password"
          className="block text-lg font-medium mb-2"
        >
          New Password
        </label>
        <input
          id="new_password"
          type="password"
          name="new_password"
          value={input.new_password}
          onChange={handleInput}
          placeholder="Enter your new password"
          className="border rounded px-4 py-3 w-full text-lg"
        />
      </div>
      <div className="mb-6">
        <label
          htmlFor="confirm_password"
          className="block text-lg font-medium mb-2"
        >
          Confirm New Password
        </label>
        <input
          id="confirm_password"
          type="password"
          name="confirm_password"
          value={input.confirm_password}
          onChange={handleInput}
          placeholder="Confirm your new password"
          className="border rounded px-4 py-3 w-full text-lg"
        />
      </div>
      <button
        type="submit"
        className="bg-blue-500 text-white px-6 py-3 rounded text-lg"
      >
        Change Password
      </button>
    </form>
  );
};

export default ChangePassword;
